import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { READ_ONLY_SITE_IDS } from './perimetre.constants';

@Injectable({
  providedIn: 'root'
})
export class PerimetreService {

    private _perimetreSource = new BehaviorSubject(null);
    private _perimetreDisabled = new BehaviorSubject(false);
    public perimetre$ = this._perimetreSource.asObservable();
    public perimetreDisabled$ = this._perimetreDisabled.asObservable();

    public changePerimetre(newPerimetre){
        sessionStorage.setItem('perimetre',JSON.stringify(newPerimetre));
        this._perimetreSource.next(newPerimetre);
    }

    public disablePerimetre(disabled){
        this._perimetreDisabled.next(disabled);
    }

    /**
     * Indique si le périmètre est un site ouvert en lecture seule.
     * Sans argument, le périmètre courant est lu depuis la session.
     * Un périmètre de type organisation n'est jamais en lecture seule,
     * même s'il contient un site verrouillé.
     */
    public isReadOnlyPerimetre(perimetre?: any): boolean {
        const target = perimetre !== undefined ? perimetre : this.getPerimetreFromSession();
        if (!target || target.dataType !== 'site') { return false; }
        return READ_ONLY_SITE_IDS.includes(target._id || target.id);
    }

    private getPerimetreFromSession(): any {
        try {
            return JSON.parse(sessionStorage.getItem('perimetre'));
        } catch (err) {
            return null;
        }
    }

  constructor() { }
}
